<script setup lang="ts">
  import { VNotification } from "@krainovsd/vue-ui";
  import { computed, useTemplateRef } from "vue";
  import { notification$ } from "@/entities/tech";

  const noticeRef = useTemplateRef("notice");
  const createNotification = computed(() => noticeRef.value?.createNotification);
  notification$.useSubscribe((value) => {
    createNotification.value?.(value.text, value.title, value);
  });
</script>

<template>
  <VNotification
    ref="notice"
    :default-type="'error'"
    :default-duration="8"
    :max-count="3"
    :position="'top-right'"
  >
    <slot></slot>
  </VNotification>
</template>

<style lang="scss" module></style>
